<template>
  <div class="app-container">
    <div class="screeBox">
      <el-select
        class="screenInput"
        filterable
        v-model="screen.park_id"
        placeholder="请选择园区"
        :disabled="userInfo.park_id != 0"
        @change="parkChange"
        ><el-option label="全部园区" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in parkList"
          :key="index"
        ></el-option>
      </el-select>
      <el-select
        class="screenInput"
        filterable
        v-model="screen.user_id"
        placeholder="请选择用户"
      >
        <el-option label="全部用户" value=""></el-option>
        <el-option
          v-for="(item, index) in agoList"
          :key="index"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-select
        class="screenInput"
        filterable
        v-model="screen.user_id"
        placeholder="请选择用户"
      >
        <el-option label="全部用户" value=""></el-option>
        <el-option
          v-for="(item, index) in agoList"
          :key="index"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      
      <el-select
        class="screenInput"
        filterable
        v-model="screen.star"
        placeholder="请选择星级"
      >
        <el-option label="全部星级" value=""></el-option>
        <el-option label="一星" value="1"></el-option>
        <el-option label="二星" value="2"></el-option>
        <el-option label="三星" value="3"></el-option>
        <el-option label="四星" value="4"></el-option>
        <el-option label="五星" value="5"></el-option>
      </el-select>
      <el-select
        class="screenInput"
        filterable
        v-model="screen.express_status"
        placeholder="请选择订单状态"
      >
        <el-option label="全部状态" value=""></el-option>
        <el-option label="待支付" value="1"></el-option>
        <el-option label="待发货" value="2"></el-option>
        <el-option label="待收货" value="3"></el-option>
        <el-option label="待评论" value="4"></el-option>
        <el-option label="已取消" value="5"></el-option>
      </el-select>
      <el-date-picker
        style="margin-right: 10px"
        v-model="timeValue"
        type="datetimerange"
        value-format="yyyy-MM-dd HH:mm:ss"
        range-separator="至"
        start-placeholder="订单开始日期"
        end-placeholder="订单结束日期"
      >
      </el-date-picker>
      <el-button type="primary" @click="(screen.page = 1), fetchData()"
        >搜索</el-button
      >
      <el-button type="primary" plain @click="reset()">重置</el-button>
    </div>
    <!-- <el-button
      type="primary"
      @click="addMenu(0)"
      style="margin-top: 5px"
      v-if="roles.includes('/mall/product_add')"
      >添加</el-button
    > -->
    <el-table
      max-height="700"
      v-loading="listLoading"
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>

      <el-table-column label="所属园区" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.park ? scope.row.park.name : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="订单编号" min-width="210">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.order_num }}</div>
        </template>
      </el-table-column>
      <el-table-column label="订单用户" min-width="210">
        <template slot-scope="scope">
          <div class="line2" v-if="scope.row.user">
            {{ scope.row.user.name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="微信支付订单号" min-width="210">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.transaction_id }}</div>
        </template>
      </el-table-column>
      <el-table-column label="单价" min-width="150">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.user.price }}</div>
        </template>
      </el-table-column>
      <el-table-column label="数量" min-width="100">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.number }}</div>
        </template>
      </el-table-column>
      <el-table-column label="总价" min-width="150">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.user.total }}</div>
        </template>
      </el-table-column>
      <el-table-column label="付款状态" min-width="210">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.order_status == 1" type="info">待付款</el-tag>
          <el-tag v-else-if="scope.row.order_status == 2" type="success"
            >付款成功</el-tag
          >
          <el-tag v-else-if="scope.row.order_status == 3" type="danger"
            >付款失败</el-tag
          >
          <el-tag v-else-if="scope.row.order_status == 4" type="warning"
            >取消支付</el-tag
          >
          <el-tag v-else-if="scope.row.order_status == 5" type="danger"
            >已退款</el-tag
          >
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" min-width="210">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.create_time }}</div>
        </template>
      </el-table-column>
      <el-table-column label="支付时间" min-width="210">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.pay_time }}</div>
        </template>
      </el-table-column>
      <el-table-column label="退款时间" min-width="210">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.refund_time }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_at"
        label="操作"
        fixed="right"
        min-width="210"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="danger"
            @click="refund(scope.row.id)"
            v-if="roles.includes('/mall/order_refund')"
            >退款</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="openExpress(scope.row.id)"
            v-if="roles.includes('/mall/order_express')"
            >发货</el-button
          >
          <!-- <el-button
            size="mini"
            type="success"
            @click="handleEdit(scope.row.id)"
            v-if="roles.includes('/mall/product_edit')"
            >编辑</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="shopForm"
        :rules="rules"
        ref="shopForm"
        label-width="120px"
        class="demo-shopForm"
      >
        <el-form-item label="选择园区" prop="park_id">
          <el-select
            filterable
            v-model="shopForm.park_id"
            placeholder="请选择园区"
            :disabled="czType == 'see' || userInfo.park_id != 0"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品名称" prop="title">
          <el-input
            class="w4"
            :disabled="czType == 'see'"
            v-model="shopForm.title"
            placeholder="请输入商品名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="序号" prop="sort">
          <el-input
            :disabled="czType == 'see'"
            class="w4 numInput"
            v-model="shopForm.sort"
            placeholder="请输入序号"
            type="number"
            min="0"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="czType == 'add'"
            type="primary"
            @click="submitForm('shopForm')"
          >
            立即创建
          </el-button>
          <el-button
            v-if="czType == 'edit'"
            type="primary"
            @click="editForm('shopForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="czType == 'edit'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button
            v-if="czType == 'add'"
            type="info"
            @click="resetForm('shopForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
    <el-dialog title="发货" :visible.sync="dialogVisible" width="500px">
      <el-form ref="expressForm" :model="expressForm" label-width="120px">
        <el-form-item
          :rules="[
            { required: true, message: '请输入快递公司名称', trigger: 'blur' },
          ]"
          prop="express_name"
          label="快递公司名称"
        >
          <el-input v-model="expressForm.express_name"></el-input>
        </el-form-item>
        <el-form-item
          :rules="[
            { required: true, message: '请输入快递公司单号', trigger: 'blur' },
          ]"
          prop="express_sn"
          label="快递单号"
        >
          <el-input v-model="expressForm.express_sn"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="express('expressForm')"
            >确 定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { openPark, adminUser, agoList } from "@/api/index";
import { mapGetters } from "vuex";
import { commentLists, orderRefund, orderExpress } from "@/api/shop";
import { getToken } from "@/utils/auth";
import Editor from "@/components/Editor";
export default {
  components: { Editor },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      token: getToken(),
      ossUpload: this.$store.state.ossUpload,
      listLoading: false,
      screen: {
        is_page: 1,
        page: 1,
        page_size: 15,
        park_id: "",
        user_name: "",
        user_phone: "",
        order_num: "",
      },
      parkList: [],
      list: [],
      total: 0,
      drawerTitle: "",
      czType: "",
      drawer: false,
      shopForm: {},
      imageList: [],
      bannerList: [],
      rules: {
        park_id: [{ required: true, message: "请选择园区", trigger: "change" }],
        title: [{ required: true, message: "请输入商品名称", trigger: "blur" }],
        sort: [{ required: true, message: "请输入序号", trigger: "blur" }],
      },
      timeValue: [],
      dialogVisible: false,
      expressForm: {
        id: "",
        express_name: "",
        express_sn: "",
      },
      agoList: [],
    };
  },
  created() {
    this.fetchData();
    this.getPark();
  },
  methods: {
    parkChange(e) {
      agoList({ park_id: e }).then((res) => {
        console.log(res.data.data);
        this.agoList = res.data.data;
      });
    },
    getAgo(e) {},
    // 订单退款
    refund(id) {
      var that = this;
      this.$confirm("确认退款？")
        .then(() => {
          orderRefund({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    // 打开发货页面
    openExpress(id) {
      this.expressForm = {
        id: id,
        express_name: "",
        express_sn: "",
      };
      this.dialogVisible = true;
    },
    // 订单发货
    express(id) {
      var that = this;
      this.$confirm("确认发货？")
        .then(() => {
          orderExpress(that.expressForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    // 查看按钮
    handleInfo(id) {
      this.drawerTitle = "查看";
      this.czType = "see";
      this.getPark();
      this.getInfo(id);
    },
    // 编辑按钮
    handleEdit(id) {
      this.drawerTitle = "编辑";
      this.czType = "edit";
      this.getPark();
      this.getInfo(id);
    },
    getInfo(id) {
      var that = this;
      productTypeInfo({ id: id }).then((res) => {
        console.log(res);
        that.shopForm = {
          id: res.data.info.id,
          title: res.data.info.title,
          park_id: res.data.info.park_id,
          sort: res.data.info.sort,
        };
        that.drawer = true;
      });
    },
    // 编辑
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.shopForm);
          productTypeEdit(that.shopForm).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.drawer = false;
              that.fetchData();
            }
          });
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });
          return false;
        }
      });
    },
    // 添加
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.shopForm);
          productTypeAdd(that.shopForm).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.drawer = false;
              that.fetchData();
            }
          });
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });
          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.shopForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    // 分页
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 分页 end
    // 重置
    reset() {
      this.screen = {
        is_page: 1,
        page: 1,
        page_size: 15,
        park_id: "",
        order_num: "",
        user_id: "",
        order_status: "",
        user_name: "",
        user_phone: "",
        express_status: "",
      };
      this.timeValue = [];
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 获取数据
    fetchData() {
      console.log(this.timeValue);
      this.screen.start_time = this.timeValue[0];
      this.screen.end_time = this.timeValue[1];
      this.listLoading = true;
      commentLists(this.screen).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.screeBox {
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 16px;
  .screenInput {
    width: 200px;
    margin-right: 10px;
    margin-bottom: 10px;
  }
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
.w4 {
  width: 40%;
}
//去除动画
::v-deep .el-list-enter-active,
::v-deep .el-list-leave-active {
  transition: all 0s;
}
.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
</style>
